import { useQuery } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { enqueueSnackbar } from '../../root/actions'
import { getIntegrationsAndApiData } from '../api/integrations-billing-api'

export const INTEGRATIONS_AND_API_DATA_KEY = ['integrations-and-api-data']

const BILLABLE_INTEGRATION_KEYS = ['pestscan', 'pestsoft', 'debuxx']

export function hasAnyIntegrationActive(data) {
    if (!data) return false
    if ((data.api_keys_amount ?? 0) > 0) return true
    if ((data.webhooks_amount ?? 0) > 0) return true
    const settings = data.external_integration_settings ?? {}
    return BILLABLE_INTEGRATION_KEYS.some(key => settings[key] === true)
}

export function useIntegrationsAndApiData() {
    const dispatch = useDispatch()
    const locale = useSelector(state => state.main.locale)
    const customerId = useSelector(
        state => state.main.user?.original_customer_id
    )

    return useQuery(INTEGRATIONS_AND_API_DATA_KEY, getIntegrationsAndApiData, {
        enabled: Boolean(customerId),
        refetchOnWindowFocus: false,
        onError: () => {
            dispatch(
                enqueueSnackbar({
                    message: locale.integrations.billingDataLoadFailed,
                    options: { variant: 'error' }
                })
            )
        }
    })
}
